var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Checkbox',{attrs:{"id":'remember-login-checkbox',"name":'remember-login-checkbox'},model:{value:(_vm.remember),callback:function ($$v) {_vm.remember=$$v},expression:"remember"}},[_vm._v("\n  Zapamiętaj mnie na tym komputerze\n")])}
var staticRenderFns = []

export { render, staticRenderFns }